module.exports = __webpack_public_path__ + "media/images/svg/warning-e6fde5f6424b4cd07797db361c18e97c.svg";